import { render, staticRenderFns } from "./OEMTable.vue?vue&type=template&id=6caefbdf&scoped=true"
import script from "./OEMTable.vue?vue&type=script&lang=js"
export * from "./OEMTable.vue?vue&type=script&lang=js"
import style0 from "./OEMTable.vue?vue&type=style&index=0&id=6caefbdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caefbdf",
  null
  
)

export default component.exports